import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ImageHelper } from './../../../validator/image-helper';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { SpaceService } from './../../../services/space.service';

import _ from 'lodash';

@Component({
  selector: 'app-empty-floorplan',
  templateUrl: './empty-floorplan.component.html',
  styleUrls: ['./empty-floorplan.component.scss']
})
export class EmptyFloorplanComponent implements OnInit {
  @Input() spaceData;
  @Output() uploadImagesEmit = new EventEmitter();
  @ViewChild('imageFile') imageFile: ElementRef;
  public imageSrc = 'assets/images/drag-img.png';
  accessToken: any;
  filesData = [];
  uploadObjErr: any;
  isSubmitted = false;
  selectedFile: any;
  fileText: any;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }
  onDropHandler(object) {
    this.uploadObjErr = undefined;
    this.filesData = [];
    if (object.event.dataTransfer.files.length === 0) { return; }
    if (object.event.dataTransfer.files.length > 1) {
      object.event.target.value = null;
      this.uploadObjErr = 'Please upload only one image file.';
      return;
    }

    this.selectedFile = object.event.dataTransfer.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isImageSizeExceeded(this.selectedFile.size)) {
      object.event.target.value = null;
      this.uploadObjErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isImageTypeValid(fileExtension)) {
      object.event.target.value = null;
      this.uploadObjErr = 'Please upload valid file type (i.e jpeg, jpg, png, svg).';
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile); // read file as data url
    reader.onload = (readerevent: any) => { // called once readAsDataURL is completed
      this.selectedFile.url = readerevent.target.result;
    };
  }

  onFileChangeImages(event) {
    this.uploadObjErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedFile = event.target.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isImageSizeExceeded(this.selectedFile.size)) {
      event.target.value = null;
      this.uploadObjErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isImageTypeValid(fileExtension)) {
      event.target.value = null;
      this.uploadObjErr = 'Please upload valid file type (i.e jpeg, jpg, png, svg).';
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile); // read file as data url
    reader.onload = (readerevent: any) => { // called once readAsDataURL is completed
      this.selectedFile.url = readerevent.target.result;
    };

    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
  }

  removeImage() {
    this.selectedFile = undefined;
    this.resetErrorValues();
  }

  submit() {
    if (!this.selectedFile) {
      this.uploadObjErr = 'Image is required.';
      return;
    }
    this.isSubmitted = true;
    const formData = new FormData();
    formData.append('image', this.selectedFile);
    formData.append('space_id', this.spaceData.uuid);
    this.spaceService.uploadFlooplanImage(formData, this.accessToken).subscribe(
      (response) =>  {
        this.resetErrorValues();
        const responseData = response.data;
        this.uploadImagesEmit.emit(responseData);
      }, err => {
        this.uploadObjErr = err.message;
      }
    );

  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.uploadObjErr = undefined;
    this.isSubmitted = false;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
  }

  resetErrorsImage() {
    this.uploadObjErr = undefined;
  }

}
